import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import store from "../../../../../redux/store";
import adminController from "../../../../../apis/Controllers/AdminControler/admin.controller";
import permissionsController from "../../../../../apis/Controllers/PermissionsController/permissions.contoller";

const StaffDetailFunctions = () => {
    var breadcrumData = ["Dashboard", "Staff List"];
    const [breadcrumItem, setbreadcrumItem] = useState("");
    const [loader, setLoader] = useState(false);
    const [staffDetail, setStaffDetail] = useState(null);
    const [checkTaskPermissions, setCheckTaskPermissions] = useState(null);
    const [checkLogsPermissions, setLogsCheckPermissions] = useState(null);
    const [tabs, setTabs] = useState([]);
    const loaction = useLocation();
    const navigate = useNavigate();
    let userdata = localStorage.getItem('SET_USER_DATA');
    let User = JSON.parse(userdata);
    const defaultTabs = [
        {
            id: 1,
            tabTitle: "Task",
        },
        {
            id: 2,
            tabTitle: "Logs",
        },
    ];


    useEffect(() => {
        if (checkTaskPermissions) {
            let tabBar = [...tabs]
            if (checkTaskPermissions
                && checkTaskPermissions.permissions
                && checkTaskPermissions.permissions.length > 0
                && parseInt(checkTaskPermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Task')
                if (checkId === -1) {
                    tabBar.push({
                        id: 1,
                        tabTitle: "Task",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkTaskPermissions]);


      useEffect(() => {
        if (checkLogsPermissions) {
            let tabBar = [...tabs]
            if (checkLogsPermissions
                && checkLogsPermissions.permissions
                && checkLogsPermissions.permissions.length > 0
                && parseInt(checkLogsPermissions.permissions[0].value) === 1) {
                let checkId = tabBar.findIndex((item) => item.tabTitle === 'Logs')
                if (checkId === -1) {
                    tabBar.push({
                        id: 2,
                        tabTitle: "Logs",
                    })
                }
                else;
            }
            else {
                return tabBar
            }
            setTabs(tabBar);
        }
    }, [checkLogsPermissions]);


    const getTaskModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('task');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setCheckTaskPermissions(data);
        }
        else {
            setCheckTaskPermissions(null);
        }
    };

    
    const getLogsModulePermissions = async () => {
        let response = await permissionsController.permissionsDetails('log');
        if (response && response.status) {
            let data = response && response.data && response.data.length > 0 ? response.data[0] : ''
            setLogsCheckPermissions(data);
        }
        else {
            setLogsCheckPermissions(null);
        }
    };


    const getStaffDetails = async (id) => {
        setLoader(true);
        let response = await adminController.adminDetail(id);
        if (response && response.status) {
            setStaffDetail(response.data);
            setLoader(false);
        } else {
            setStaffDetail(null);
            setLoader(false);
        }
    };


    const handleBreadcrumDataNaviagtion = (i) => {
        let user = store.getState().UserReducer.user;
        if (i === 0) {
            if (user && parseInt(user.user_type) === 2) {
                navigate("/dashboard");
            } else {
                navigate("/dashboard-superadmin");
            }
        } else if (i === 1) {
            navigate("/staff-list");
        } else return;
    };


    return {
        User,
        checkTaskPermissions,
        getTaskModulePermissions,
        getLogsModulePermissions,
        checkLogsPermissions,
        tabs, 
        setTabs,
        defaultTabs,
        loader,
        breadcrumItem,
        setbreadcrumItem,
        breadcrumData,
        loaction,
        navigate,
        getStaffDetails,
        staffDetail,
        handleBreadcrumDataNaviagtion,
    };
};

export default StaffDetailFunctions;
